import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { editionOptions } from '../utils/bibleEditions';
import './EditionSwitcher.css';

export default function EditionSwitcher({ mobile }) {
  const location = useLocation();
  const navigate = useNavigate();
  const options = editionOptions(location.pathname);
  const requested = new URLSearchParams(location.search).get('type');
  const current = options.find(option => option.value === requested) || options[0];
  const href = (type) => {
    const params = new URLSearchParams(location.search);
    params.set('type', type);
    return `${location.pathname}?${params.toString()}${location.hash}`;
  };

  if (!mobile) return (
    <nav className="ll" aria-label="聖書の訳を選ぶ">
      {options.map(option => (
        <a key={option.value} className="al lang-button" href={href(option.value)} aria-current={current.value === option.value ? 'true' : undefined}>
          {option.shortLabel}
        </a>
      ))}
    </nav>
  );

  return (
    <div className="edition-picker">
      <div className="edition-picker__face" aria-hidden="true">
        <svg className="edition-picker__book" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
          <path d="M12 5v15M12 5C9 3 5 3 2 4v15c3-1 7-1 10 1 3-2 7-2 10-1V4c-3-1-7-1-10 1Z" />
        </svg>
        <span className="edition-picker__caption">訳を選ぶ</span>
        <span className="edition-picker__current">{current.label}</span>
        <svg className="edition-picker__chevron" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="m4 6 4 4 4-4" /></svg>
      </div>
      <select aria-label="聖書の訳を選ぶ" value={current.value} onChange={event => navigate(href(event.target.value))}>
        {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
      </select>
    </div>
  );
}
